<template>
  <div class="flex flex-col h-full">
    <div class="flex-auto overflow-scroll">
      <h3 class="text-2xl font-bold pt-4 px-4">Esquemas de precios</h3>

      <div class="sm:hidden px-4 pb-4">
        <router-link
          v-for="pricing in pricings"
          :key="pricing.id"
          :to="`/admin/pricing/${pricing.id}`"
          class="block border rounded bg-white p-4 mt-4"
        >
          <div class="flex items-center justify-between">
            <p class="font-bold text-lg">{{ pricing.nombre }}</p>
            <span class="text-sm text-gray-500">
              {{ pricing.active_provider_count }} activos
            </span>
          </div>
          <div class="grid grid-cols-2 gap-2 mt-3 text-sm">
            <span class="text-gray-500">Tarima</span>
            <span class="text-right">{{ formatMoney(pricing.almacen) }}</span>
            <span class="text-gray-500">Envío base</span>
            <span class="text-right">{{ formatMoney(pricing.envio_base) }}</span>
            <span class="text-gray-500">Km adicional</span>
            <span class="text-right">{{ formatMoney(pricing.envio_adicional) }}</span>
            <span class="text-gray-500">Express semana</span>
            <span class="text-right">{{ formatMoney(pricing.express_entre_semana) }}</span>
            <span class="text-gray-500">Express fin de semana</span>
            <span class="text-right">{{ formatMoney(pricing.express_fin_de_semana) }}</span>
          </div>
        </router-link>
      </div>

      <div v-if="pricings.length" class="hidden sm:block p-4">
        <div class="border border-b-0 rounded bg-white overflow-scroll">
          <table class="w-full text-sm text-left">
            <thead class="border-b border-b-gray-200">
              <tr>
                <th class="py-3 px-6">Nombre</th>
                <th class="py-3 px-6">Activos</th>
                <th class="py-3 px-6">Tarima</th>
                <th class="py-3 px-6">Envío base</th>
                <th class="py-3 px-6">Km adicional</th>
                <th class="py-3 px-6">Express semana</th>
                <th class="py-3 px-6">Express fin de semana</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="pricing in pricings"
                :key="pricing.id"
                class="border-b cursor-pointer hover:bg-gray-50 focus:bg-gray-50 focus:outline-none"
                role="link"
                tabindex="0"
                @click="openPricing(pricing.id)"
                @keyup.enter="openPricing(pricing.id)"
              >
                <td class="py-3 px-6 font-medium underline">{{ pricing.nombre }}</td>
                <td class="py-3 px-6">{{ pricing.active_provider_count }}</td>
                <td class="py-3 px-6">{{ formatMoney(pricing.almacen) }}</td>
                <td class="py-3 px-6">{{ formatMoney(pricing.envio_base) }}</td>
                <td class="py-3 px-6">{{ formatMoney(pricing.envio_adicional) }}</td>
                <td class="py-3 px-6">{{ formatMoney(pricing.express_entre_semana) }}</td>
                <td class="py-3 px-6">{{ formatMoney(pricing.express_fin_de_semana) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="loaded && !pricings.length" class="p-4 text-gray-500">
        No hay esquemas de precios.
      </div>
    </div>

    <div class="p-4 flex-none border-t border-t-gray-300">
      <router-link to="/admin/pricing">
        <button class="w-full bg-primary hover:bg-primary-dark rounded text-white font-bold py-2 px-4">
          Crear esquema de precios
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useLoading } from "vue-loading-overlay";
import { useToast } from "vue-toast-notification";
import axios from "axios";

export default {
  name: "Admin Pricings",
  setup() {
    const router = useRouter();
    const pricings = ref([]);
    const loaded = ref(false);
    const loading = useLoading({ color: "#428b74", loader: "spinner" });

    function formatMoney(value) {
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(Number(value || 0));
    }

    function openPricing(pricingId) {
      router.push(`/admin/pricing/${pricingId}`);
    }

    onMounted(async () => {
      const loader = loading.show();
      try {
        const response = await axios.get("/api/pricings");
        pricings.value = response.data || [];
      } catch (error) {
        useToast().error(
          error.response?.data?.error || "No se pudieron cargar los esquemas de precios",
          { position: "top-right" }
        );
      } finally {
        loaded.value = true;
        loader.hide();
      }
    });

    return { pricings, loaded, formatMoney, openPricing };
  },
};
</script>
